import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { SelectMsisdnMigrationDatePage } from "@nju/feature-portal-msisdn";
import { RespectOrchestratorState } from "@nju/feature-portal-orchestrator";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../../../components/ClientSideRenderer";

export default function MigrationDate() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent>
        <ClientSideOnly>
          <RespectOrchestratorState mode="mobile" state="MNP">
            <SelectMsisdnMigrationDatePage sourceContractType="PREPAID" />
          </RespectOrchestratorState>
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
